import { ErrorResponse } from 'pages/AuthorizePaymentPage/interCompany/types';
import type { CheckWritingResponse } from 'adapters/types';

export const checkWritingResponse: CheckWritingResponse = {
  printOkList: [
    {
      vendorNo: '2021',
      vendorName: 'V2021',
      checkNumber: '5001',
      checkAmount: '$13.10',
      status: 'PRINTED',
      errorText: '',
      errorCode: ''
    },
    {
      vendorNo: '2022',
      vendorName: 'V2022',
      checkNumber: '5002',
      checkAmount: '$13.20',
      status: 'PRINTED',
      errorText: 'Update invoice records error',
      errorCode: 'E1342'
    },
    {
      vendorNo: '2023',
      vendorName: 'V2023',
      checkNumber: '5003',
      checkAmount: '$13.30',
      status: 'PRINTED',
      errorText: 'Rendering of the form failed',
      errorCode: 'E1343'
    }
  ],
  printFailureList: [
    {
      vendorNo: '2024',
      vendorName: 'V2024',
      checkNumber: '',
      checkAmount: '$14.10',
      status: 'FAILED',
      errorText: 'CheckRequest validation failed due to invoice lock in DMS',
      errorCode: 'E2341'
    },
    {
      vendorNo: '2025',
      vendorName: 'V2025',
      checkNumber: '',
      checkAmount: '$14.20',
      status: 'FAILED',
      errorText: 'Unprinted due to previous check being partial',
      errorCode: 'E2342'
    }
  ]
};

export const responseWithPartiallyFailedChecks: CheckWritingResponse = {
  printOkList: [
    {
      vendorNo: '2021',
      vendorName: 'V2021',
      checkNumber: '5001',
      checkAmount: '$13.10',
      status: 'PRINTED',
      // errorText: 'Archive error',
      // errorCode: 'E100'
      errorCode: '',
      errorText: ''
    },
    {
      vendorNo: '2022',
      vendorName: 'V2022',
      checkNumber: '5002',
      checkAmount: '$13.20',
      status: 'PRINTED',
      errorText: 'General Ledger error',
      errorCode: 'E200'
    },
    {
      vendorNo: '2023',
      vendorName: 'V2023',
      checkNumber: '5003',
      checkAmount: '$13.30',
      status: 'PRINTED',
      // errorText: 'Form Error',
      // errorCode: 'E300'
      errorCode: '',
      errorText: ''
    }
  ],
  printFailureList: []
};

export const printChecksErrorResponse: ErrorResponse = {
  httpStatusCode: '500',
  issues: [
    {
      id: '1234',
      issue: 'Check number 1234 already exists. Please use a different number.',
      severity: 'high'
    }
  ],
  uri: 'https://api-dev-system-url-invalid'
};
